let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("93iKV")).then(() => parcelRequire('g11iI'));